export const ROUTES = {
  BASE: '/direct-billing',
  BASE_NO_SLASH: 'direct-billing',
  LOGIN_REDIRECT: 'login-redirect',
  START: 'start',
  RESUME: 'resume',
  ELIGIBLE_INSURERS: 'insurers',
  INSURANCE_MEMBER: 'insurance-member',
  INSURANCE_INFORMATION: 'insurance-information',
  QUOTE: 'quote',
  SELECT_PRESCRIPTION: 'select-prescription',
  VALIDATE_PRESCRIPTION: 'validate',
  SELECT_PRODUCT: 'select-product',
  CHANGE_COVERED_PRODUCT: 'change-product',
  REVIEW_CLAIM: 'review',
  ERROR: 'error',
  LOADING: 'loading',
  RESTRICTED: 'restricted',
}

export const ENDPOINTS = {
  DIRECT_BILLING: {
    BASE: '/services/direct-billing',
    AUTH_TOKEN: '/services/direct-billing/auth/token',
    CLAIMS: '/services/direct-billing/claims',
    CLAIM_RECORDS: '/services/direct-billing/claim-records',
    INSURERS: '/services/direct-billing/insurers',
    INSURERS_PUBLIC: '/services/direct-billing/insurers/list',
    INSURER_DETAILS: '/services/direct-billing/insurers/{{insurerId}}',
    INSURANCE_PROVIDER: '/services/direct-billing/insurance-providers/{{insuranceProviderId}}',
    INSURANCE_PROVIDER_DEFAULT_FORMS:
      '/services/direct-billing/insurance-providers/{{insuranceProviderId}}/default-insurance-forms',
    DISPENSING_PRACTITIONERS: '/services/direct-billing/dispensing-practitioners',
    SERVICE_LOCATIONS: '/services/direct-billing/service-locations',
    CONFIGURATIONS: '/services/direct-billing/configurations',
    ATTACHMENTS: '/services/direct-billing/shared-services/attachments',
  },
}

export const TELUS = {
  RELATIONSHIP: {
    SELF: 'SELF', // Insured member
    SPS: 'SPS', // Spouse
    CHILD: 'CHILD', // Child
    HANDIC: 'HANDIC', // Handicapped dependent
    PSTUD: 'PSTUD', // Part-time student
    FSTUD: 'FSTUD', // Full time student
    DOMPART: 'DOMPART', // Domestic partner
  },
  GENDER: {
    MALE: 'MALE',
    FEMALE: 'FEMALE',
    OTHER: 'OTHER',
    UNKNOWN: 'UNKNOWN',
  },
  INCIDENT_TYPE: {
    MOTOR_VEHICLE: 'MOTOR_VEHICLE',
    SCHOOL: 'SCHOOL',
    SPORT: 'SPORT',
    WORKPLACE: 'WORKPLACE',
    OTHER: 'OTHER',
  },
  DOCTOR_CREDENTIAL: {
    OPTOMETRIST: 'OPTOMETRIST',
    OPHTHALMOLOGIST: 'OPHTHALMOLOGIST',
    MEDICAL_DOCTOR: 'MEDICAL_DOCTOR',
  },
}

export const DEFAULT_FIELD_MAX_LENGTH = 50
export const POLICY_NUMBER_FIELD_MAX_LENGTH = 12
export const MEMBER_ID_FIELD_MAX_LENGTH = 12

export const ALLOWED_FILETYPES = ['image/jpeg', 'image/png', 'application/pdf']

export const MAX_FILE_SIZE_MB = 10

export const VALIDATION_ANIMATION_INTERVAL_MS = 7000

export const INSURANCE_TYPES = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
}

export const PRESCRIPTION_VALIDATION_TIMEOUT_MS = 2000

export const PRESCRIPTION_ATTRIBUTE_DISPLAY_ORDER = [
  'power',
  'baseCurve',
  'diameter',
  'sphere',
  'cylinder',
  'axis',
  'add',
  'pupillaryDistance',
  'monoPupillaryDistance',
  'dominance',
]

export const DB_APP_ROOT_CLASS = 'DBApp-root'

export const CLAIM = {
  POLLING_INTERVAL_MS: 2000,
  MAX_WAIT_TIME_MS: 2 * 60 * 1000,
  MAX_TIMEOUT_RETRY: 3,
  MAX_NULLIFY_COUNT: 3,
  MAX_NULLIFY_WAIT_TIME: 2 * 60 * 1000,
  MAX_NULLIFY_WAIT_TIME_SHORT: 5 * 1000,
  UPDATE_CART_POLLING_INTERVAL_MS: 1000,
}

export const QUOTE = {
  POLLING_INTERVAL_MS: 2000,
  MAX_WAIT_TIME_MS: 2 * 60 * 1000,
  MAX_WAIT_TIME_MS_REFUSE_QUOTE: 30 * 1000,
  MAX_TIMEOUT_RETRY: 3,
  CANCEL_QUOTE_RETRY_INTERVAL_MS: 500,
  CANCEL_QUOTE_MAX_RETRY: 3,
}

export const SYNC_INSURANCE = {
  POLLING_INTERVAL_MS: 2000,
  MAX_WAIT_TIME_MS: 2 * 60 * 1000,
  MAX_TIMEOUT_RETRY: 3,
}

export const FORM_ACTION_INVOKE_THRESHOLD = 60000

export const PREFER_CACHE = true
